import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import App from './App';
import router from './router';
import store from './store';
import { Toast } from '@nutui/nutui';
import './registerServiceWorker';
import '@/style/reset.less';
import '@/style/main.less';
import wx from 'weixin-js-sdk'
import {wxConfig} from '@/services/package';
import '@/assets/ts/isWeixinCient'

import '@/utils/watchOpenId'
import getOpenId from '@/utils/openId';

Toast.install(Vue)

Vue.use(VueAxios, axios)

Vue.config.productionTip = false;


window.onload = function() { //在页面整体加载完毕时
    const element: any = document.getElementById('app');
    element.style.height = document.documentElement.clientHeight + 'px'
}
// 不允许分享的页面
let hideShareMenu = ['/abnormalMsg', '/equipmentList','/equipmentlist', '/applicationList', '/bindUser', '/unbindUser']
router.afterEach(async (to, from) => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    // 判断是否是微信环境，如果不是微信环境，则不执行微信注入
    if (sessionStorage.isWeixinCent === 'false'){
        return
    }

    // 获取openId
    await getOpenId(to.query.code, to.fullPath)

    // 如果有当前页面的注入信息
    let response = await wxConfig(to.fullPath)
    // // 判断是否已经请求过当前的注入信息
    // const sessWXConfig = sessionStorage.getItem('wxConfigParams') || ''
    // let wxConfigParams = sessWXConfig ? JSON.parse(sessWXConfig) : null
    // let response
    //
    // if(!wxConfigParams || !wxConfigParams[to.fullPath]) {
    //     // 如果有当前页面的注入信息
    //     response = await wxConfig(to.fullPath)
    //     if(wxConfigParams) {
    //         wxConfigParams[to.fullPath] = response
    //     }
    //     sessionStorage.setItem('wxConfigParams', JSON.parse(wxConfigParams))
    // } else {
    //     response = wxConfigParams[to.fullPath]
    // }

    if(response && response.code === 10000 && response.result) {
    
        const getCookie = (name) => {
            let arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
            return (arr=document.cookie.match(reg))?unescape(arr[2]):null;
        }
    
        const authInfo = getCookie('auth_info')
    
    
        if (authInfo && authInfo !== 'null') {
            if (window.location.pathname === '/') {
                router.push({ path: 'home' })
            }
        }
        // 注入微信
        wx.config({
            appId: response.result.appid, // 必填，公众号的唯一标识
            timestamp: response.result.timestamp, // 必填，生成签名的时间戳
            nonceStr: response.result.noncestr, // 必填，生成签名的随机串
            signature: response.result.sign,// 必填，签名
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone', 'chooseWXPay', 'hideAllNonBaseMenuItem'] // 必填，需要使用的JS接口列表
        })
    }
    // 注入微信成功
    wx.ready(function () {
        // 异常消息页面禁止分享 隐藏非基础按钮接口
        if(hideShareMenu.indexOf(to.path) != -1) {
            wx.hideAllNonBaseMenuItem();
        }


        const link = window.location.origin + '/share'

        // 分享给朋友 及“分享到QQ”
        wx.updateAppMessageShareData({
            title: '爱云兔云手机', // 分享标题
            desc: '手游智能云托管，7*24小时云端运行', // 分享描述
            link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'https://cphonepic-1252422369.cos.ap-beijing.myqcloud.com/img/iyuntu_logo.jpg', // 分享图标
            success: function () {
                // 设置成功
                console.log('ok')
            }
        })

        // 分享给朋友
        wx.onMenuShareAppMessage({
            title: '爱云兔云手机', // 分享标题
            desc: '手游智能云托管，7*24小时云端运行', // 分享描述
            link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'https://cphonepic-1252422369.cos.ap-beijing.myqcloud.com/img/iyuntu_logo.jpg', // 分享图标
            success: function () {
                // 设置成功
                console.log('ok')
            }
        })

        // 分享到朋友圈 及“分享到QQ空间
        wx.updateTimelineShareData({
            title: '爱云兔云手机', // 分享标题
            link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'https://cphonepic-1252422369.cos.ap-beijing.myqcloud.com/img/iyuntu_logo.jpg', // 分享图标
            success: function () {
                // 设置成功
                console.log('ok')
            }
        })

        // 分享到朋友圈
        wx.onMenuShareTimeline({
            title: `爱云兔云手机`, // 分享标题
            link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'https://cphonepic-1252422369.cos.ap-beijing.myqcloud.com/img/iyuntu_logo.jpg' // 分享图标
        })

        // 分享到腾讯微博
        wx.onMenuShareWeibo({
            title: '爱云兔云手机', // 分享标题
            desc: '手游智能云托管，7*24小时云端运行', // 分享描述
            link: link, // 分享链接
            imgUrl: 'https://cphonepic-1252422369.cos.ap-beijing.myqcloud.com/img/iyuntu_logo.jpg', // 分享图标
            success: function () {
                // 用户确认分享后执行的回调函数
            },
            cancel: function () {
                // 用户取消分享后执行的回调函数
            }
        })
    })


})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
